//Reducer Types
interface State {
  machineList: any;
  machineCount: number;
  productTypeList: any;
  quoteAdditionalData: any;
  qualityCheckList: any;
  qualityCheckCount: number;
  readinessCheckList: any;
  readinessCheckCount: number;
  dispatchCheckList: any;
  dispatchCheckCount: number;
}

export const masterDataReducer = (
  state: State = {
    machineList: [],
    machineCount: 0,
    productTypeList: [],
    quoteAdditionalData: [],
    qualityCheckList: [],
    qualityCheckCount: 0,
    readinessCheckList: [],
    readinessCheckCount: 0,
    dispatchCheckList: [],
    dispatchCheckCount: 0,
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_MACHINE_DATA":
      return {
        ...state,
        machineList:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.machineList, ...action.payload?.data],
        machineCount: action.payload.count,

        // detail:action.payload.detail
      };
    case "UPDATE_MACHINE_DATA":
      return {
        ...state,
        machineList: state?.machineList?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    case "DELETE_MACHINE":
      return {
        ...state,
        machineList: state?.machineList?.filter(
          (elem: any) => elem?._id !== action?.payload,
        ),
        machineCount: state?.machineCount - 1,
      };
    case "CLEAR_MACHINE_DATA":
      return {
        ...state,
        machineList: [],
      };

    case "GET_PRODUCT_TYPE":
      return {
        ...state,
        productTypeList: action.payload,
      };
    case "GET_QUOTE_ADDITIONAL_DATA":
      return {
        ...state,
        quoteAdditionalData:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.quoteAdditionalData, ...action.payload?.data],
      };

    case "GET_QUALITY_CHECK_DATA":
      return {
        ...state,
        qualityCheckList: action.payload?.data,
        qualityCheckCount: action.payload?.count,
      };
    case "SET_QUALITY_CHECK_DATA":
      return {
        ...state,
        qualityCheckList: action.payload?.data,
      };
    case "GET_READINESS_CHECK_DATA":
      return {
        ...state,
        readinessCheckList: action.payload?.data,
        readinessCheckCount: action.payload?.count,
      };
    case "GET_DISPATCH_CHECKLIST_DATA":
      return {
        ...state,
        dispatchCheckList: action.payload?.data,
        dispatchCheckCount: action.payload?.count,
      };
    case "CLEAR_DISPATCH_CHECK_DATA":
      return {
        ...state,
        dispatchCheckList: [],
      };
    default:
      return state;
  }
};
